export const home = {
  hero: {
    title: 'Apporter de l\'espoir aux réfugiés en RDC',
    subtitle: 'Aide d\'urgence, soins de santé, éducation et abris pour les communautés vulnérables',
    donateButton: 'Faire un don',
    learnMoreButton: 'En savoir plus',
  },
  impact: {
    badge: 'Notre Impact',
    title: 'Changer des vies chaque jour',
    subtitle: 'Des chiffres réels derrière un changement réel — chaque chiffre représente une vie touchée, une famille soutenue et un avenir restauré.',
    counters: {
      livesHelped: 'Vies Aidées',
      livesHelpedDesc: 'Personnes et familles ayant reçu un soutien humanitaire direct',
      mealsProvided: 'Repas Fournis',
      mealsProvidedDesc: 'Repas nutritifs livrés aux familles déplacées et aux enfants',
      sheltersBuilt: 'Abris Construits',
      sheltersBuiltDesc: 'Abris sûrs et dignes construits pour les familles déplacées',
      childrenEducated: 'Enfants Éduqués',
      childrenEducatedDesc: 'Enfants ayant accès à une éducation de qualité malgré le déplacement',
    },
    growthTitle: 'Notre parcours au fil des années',
    milestones: {
      founded: 'Fondée',
      expanded: 'Étendue à 3 régions',
      clinics: '10 Cliniques Mobiles',
      schools: '25 Écoles Soutenues',
      shelters: '8 400 Abris Construits',
    },
  },
  projects: {
    title: 'Nos projets actifs',
    subtitle: 'Faire une réelle différence dans la vie des réfugiés et des communautés vulnérables grâce à des programmes ciblés et des solutions durables.',
    viewProject: 'Voir le projet',
    viewAll: 'Voir tous les projets',
    active: 'Actif',
    completed: 'Terminé',
  },
  testimonials: {
    badge: 'Histoires d\'espoir',
    title: 'Voix du terrain',
    subtitle: 'Écoutez les personnes dont la vie a été transformée grâce à votre soutien — dans leurs propres mots, photos et vidéos.',
    tabs: {
      all: 'Toutes les histoires',
      photo: 'Photo',
      video: 'Vidéo',
      text: 'Texte',
    },
  },
  news: {
    title: 'Dernières nouvelles et mises à jour',
    subtitle: 'Restez informé de nos activités récentes, de nos réussites et des mises à jour sur le terrain en République démocratique du Congo',
    readMore: 'Lire la suite',
    viewAll: 'Voir toutes les nouvelles et mises à jour',
  },
  cta: {
    badge: 'Faites la différence aujourd\'hui',
    title: 'Votre soutien peut',
    titleItalic: 'Changer des vies pour toujours',
    subtitle: 'Chaque don, quelle que soit sa taille, apporte espoir, dignité et un avenir meilleur aux réfugiés et aux communautés vulnérables en République démocratique du Congo.',
    donateButton: 'Faire un don',
    secureText: 'Don sécurisé via Stripe et PayPal',
  },
};
